/**
 * Gen1 Quad relay device template
 * Used by: SHSW-44 (Shelly 4Pro - 4-channel relay with PM)
 *
 * Gen1 devices use HTTP endpoints instead of RPC
 */

import {
	createGen1TurnAction,
	createGen1StateCondition,
	createGen1StateChangedTrigger,
} from './stateManagement.js';
import { createGen1PowerLevelCondition, createGen1PowerThresholdTrigger } from './powerMonitoring.js';

/**
 * Quad (4-channel) relay with power monitoring
 */
export function createGen1QuadRelayPMTemplate(maxPowerPerChannel = 1840) {
	return {
		deviceType: 'gen1_quad_relay_pm',
		generation: 1,
		channels: ['relay:0', 'relay:1', 'relay:2', 'relay:3'],
		actions: {
			turn: createGen1TurnAction('relay', true),
		},
		conditions: {
			isOn: createGen1StateCondition('relay'),
			powerLevel: createGen1PowerLevelCondition(maxPowerPerChannel),
		},
		triggers: {
			stateChanged: createGen1StateChangedTrigger('relay'),
			powerThreshold: createGen1PowerThresholdTrigger(maxPowerPerChannel),
		},
	};
}
